import { render, staticRenderFns } from "./EmptyStateCard.vue?vue&type=template&id=287b921c&scoped=true&lang=pug&"
import script from "./EmptyStateCard.vue?vue&type=script&lang=js&"
export * from "./EmptyStateCard.vue?vue&type=script&lang=js&"
import style0 from "./EmptyStateCard.vue?vue&type=style&index=0&id=287b921c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b921c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VAlert,VSimpleTable})
